import { createHook as i, createComponent as n, createElement as o } from "../../../ariakit-react-utils/esm/system.js";
const r = i((e) => (e = {
  ...e,
  style: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px",
    ...e.style
  }
}, e)), a = n((e) => {
  const t = r(e);
  return o("span", t);
});
process.env.NODE_ENV !== "production" && (a.displayName = "VisuallyHidden");
export {
  a as VisuallyHidden,
  r as useVisuallyHidden
};
//# sourceMappingURL=visually-hidden.js.map
